import { TeButtonMinimal, TeCallout } from '@topcon/tuicl-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { useMigrationCandidateCustomerSuggestions } from '../../../hooks/queries/migration.queries';
import featureFlags from '../../../utils/featureFlags';
import { AppRoutes } from '../../../app/routes/utils';

const CalloutWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const CalloutAction = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
`;

function CustomerMigrationCallout() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isCalloutDismissed, setIsCalloutDismissed] = useState(false);
  const { data: migrationCandidates } = useMigrationCandidateCustomerSuggestions();

  const hasMigrationCandidates =
    featureFlags.MIGRATION &&
    !isCalloutDismissed &&
    migrationCandidates?.items &&
    migrationCandidates.items.length > 0;

  if (!hasMigrationCandidates) return null;

  return (
    <CalloutWrapper>
      <TeCallout
        status="info"
        icon="info"
        heading={t('suggestedCustomers.heading')}
        text={t('suggestedCustomers.description')}
        closeable
        teclose={() => setIsCalloutDismissed(true)}
        grow
      />
      <CalloutAction>
        <TeButtonMinimal
          text={t('suggestedCustomers.reviewSuggestions')}
          size="s"
          teclick={() => navigate(AppRoutes.CustomerSuggestions)}
        />
      </CalloutAction>
    </CalloutWrapper>
  );
}

export default CustomerMigrationCallout;
